import { render, staticRenderFns } from "./reelFacebook.vue?vue&type=template&id=1a0dd3f9&"
import script from "./reelFacebook.vue?vue&type=script&lang=js&"
export * from "./reelFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports